import { useRef } from 'react'

import type { Table } from '@/components/ui/table/types'
import {
  ProcessButton,
  ProjectStateBar,
  type Statement,
  TrialProcessingNote,
  useProject,
  useStatements,
} from '@/modules/projects'
import { processButtonLabel } from '@/modules/projects/components/ProcessButton/label'
import { isProjectProcessing } from '@/modules/projects/status'
import { statementColumns } from './columns'
import { StatementsDataTable } from './DataTable'

export const StatementsTable = () => {
  const table = useRef<Table<Statement> | null>(null)

  const project = useProject()
  const statements = useStatements()
  const isProcessing = isProjectProcessing(project)
  const columns = isProcessing ? statementColumns.slice(1) : statementColumns

  return (
    <div className="flex-1 min-h-0 flex flex-col gap-3">
      <div className="flex gap-2 justify-end">
        <ProcessButton table={table.current} size="sm">
          {processButtonLabel(statements)}
        </ProcessButton>
      </div>

      <ProjectStateBar fullWidth />
      <TrialProcessingNote />

      <StatementsDataTable
        columns={columns}
        height="max-h-[60vh]"
        onTableReady={(value) => {
          table.current = value
        }}
        table={table}
        expandable
      />
    </div>
  )
}
